module.exports = __webpack_public_path__ + "img/closeicon.17faeba7.svg";